import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription, map } from 'rxjs';
import { environment } from '../../../environments/environment';

const GET_LEVEL_API_URL =
  '/api/v1/quiz/builder/niveau-question/getniveau-questions?pagination=false';
const ADD_LEVEL_API_URL =
  '/api/v1/quiz/builder/niveau-question/addniveau-question';
const UPDATE_LEVEL_API_URL =
  '/api/v1/quiz/builder/niveau-question/updateniveau-question/';

const DELETE_LEVEL_API_URL =
  '/api/v1/quiz/builder/niveau-question/deleteniveau-question/';

const BASE_URL = environment.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class NiveauQuestionService {
  constructor(private http: HttpClient) {}

  getAllLevels(): Observable<any> {
    return this.http.get<any>(`${BASE_URL}${GET_LEVEL_API_URL}`).pipe(
      map((levels) => {
        return levels;
      })
    );
  }

  createNewQuestionLevel(packLevel: any): Observable<any> {
    return this.http.post<any>(`${BASE_URL}${ADD_LEVEL_API_URL}`, {
      libelle: packLevel.libelle,
      pointdifficulte: packLevel.pointdifficulte,
      pointexperience: packLevel.pointexperience,
    });
  }

  updateQuestionLevel(packLevel: any, id: number): Observable<any> {
    const data = {
      libelle: packLevel.libelle,
      pointdifficulte: packLevel.pointdifficulte,
      pointexperience: packLevel.pointexperience,
    };
    return this.http.put<any>(`${BASE_URL}${UPDATE_LEVEL_API_URL}${id}`, data);
  }

  deleteQuestionLevelById(id: number): Observable<any> {
    return this.http.delete(`${BASE_URL}${DELETE_LEVEL_API_URL}${id}`);
  }
}
